export default {
    message: 'The {_field_} value must be a valid date.',
    validate: (value, args) => {
        //todo write this!!!
        return true;
    }
}
